import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const SOLUTIONS = [
  "CCTV Surveillance",
  "Access Control",
  "Fire Alarm Systems",
  "X-Ray & Screening",
  "Networking Solutions",
];

const COMPANY_LINKS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Contact", path: "/contact" },
];

const Footer = () => {
  const lastTapRef = useRef(0);
  const navigate = useNavigate();

  const handlePointerUp = () => {
    const now = Date.now();
    const doubleTapDelay = 300;

    if (now - lastTapRef.current < doubleTapDelay) {
      navigate("/admin/login/onlyAdmins");
    }

    lastTapRef.current = now;
  };

  const copyText = (text) => {
    navigator.clipboard.writeText(text);
    toast.success(`${text} copied!`);
  };

  return (
    <footer className="mt-16 border-t border-slate-800 bg-slate-900 pb-6 pt-14 text-slate-300">
      <div className="mx-auto grid max-w-6xl gap-10 px-6 md:grid-cols-4">
        <div>
          <h2
            className="text-xl font-extrabold text-white"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Ocellus
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-400">
            Engineering fire safety, security, and electrical infrastructure for
            commercial and industrial clients across India.
          </p>
        </div>

        <div>
          <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-slate-200">
            Solutions
          </h3>
          <ul className="space-y-2 text-sm text-slate-400">
            {SOLUTIONS.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-slate-200">
            Company
          </h3>
          <ul className="space-y-2 text-sm">
            {COMPANY_LINKS.map((link) => (
              <li key={link.label}>
                <a
                  href={link.path}
                  className="text-slate-400 hover:text-blue-400 focus:outline-none focus:text-blue-400 transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-slate-200">
            Contact
          </h3>
          <p className="text-sm leading-relaxed text-slate-400">
            Andheri (E), Mumbai – 400069
            <br />
            <button
              type="button"
              onClick={() => copyText("9967676810")}
              className="mt-1 inline-block cursor-pointer text-slate-300 underline decoration-slate-600 underline-offset-2 hover:text-blue-400"
            >
              +91 9967676810
            </button>
            <br />
            <button
              type="button"
              onClick={() => copyText("amr@ocellus.co.in")}
              className="mt-1 inline-block cursor-pointer text-slate-300 underline decoration-slate-600 underline-offset-2 hover:text-blue-400"
            >
              amr@ocellus.co.in
            </button>
          </p>
        </div>
      </div>

      <div className="mx-auto mt-10 flex max-w-6xl flex-col items-center gap-2 border-t border-slate-800 px-6 pt-6 text-xs text-slate-500 sm:flex-row sm:justify-between">
        <p>
          <button
            type="button"
            onPointerUp={handlePointerUp}
            tabIndex={-1}
            aria-hidden="true"
            className="cursor-default"
          >
            ©
          </button>{" "}
          {new Date().getFullYear()} Ocellus Business &amp; Services. All rights reserved.
        </p>
        <p>Multi-Regional Support</p>
      </div>
    </footer>
  );
};

export default Footer;